"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalApiRpcRemote = void 0;
const identifiers_1 = require("../identifiers");
const RpcRemote_1 = require("./contact/RpcRemote");
const DEFAULT_TIMEOUT = 10000;
class ExternalApiRpcRemote extends RpcRemote_1.RpcRemote {
    async externalFetchData(key) {
        const request = {
            key: (0, identifiers_1.toDhtAddressRaw)(key)
        };
        const options = this.formDhtRpcOptions({
            // TODO use options option or named constant?
            timeout: DEFAULT_TIMEOUT
        });
        try {
            const data = await this.getClient().externalFetchData(request, options);
            return data.entries;
        }
        catch {
            return [];
        }
    }
    async storeData(key, data) {
        const request = {
            key: (0, identifiers_1.toDhtAddressRaw)(key),
            data
        };
        const options = this.formDhtRpcOptions({
            // TODO use options option or named constant?
            timeout: DEFAULT_TIMEOUT
        });
        try {
            const response = await this.getClient().externalStoreData(request, options);
            return response.storers;
        }
        catch {
            return [];
        }
    }
    async externalFindClosestNode(key) {
        const request = {
            nodeId: (0, identifiers_1.toDhtAddressRaw)(key)
        };
        const options = this.formDhtRpcOptions({
            timeout: DEFAULT_TIMEOUT
        });
        try {
            const response = await this.getClient().externalFindClosestNodes(request, options);
            return response.closestNodes;
        }
        catch {
            return [];
        }
    }
}
exports.ExternalApiRpcRemote = ExternalApiRpcRemote;
//# sourceMappingURL=ExternalApiRpcRemote.js.map